import { createAction } from "@reduxjs/toolkit";
import { ISelectedSlot } from "../../types/slot.types";

enum SelectedSlotActionTypes {
    SELECTED_SLOT_RECEIVED = "[SelectedSlot] RECEIVED",
}

export const selectedSlotReceivedCreator = createAction<ISelectedSlot | null>(SelectedSlotActionTypes.SELECTED_SLOT_RECEIVED);
